import { CsI18n } from "../../shared/csI18n/csI18n";
import {
  Badge,
  Banner,
  Card,
  FormLayout,
  Layout,
  ResourceItem,
  ResourceList,
  Stack,
  Tag,
  TextField
} from "@shopify/polaris";
import HeadingHelper from "../../helpers/HeadingHelper";
import Switch from "react-switch/index";
import { CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import ResourceListHelper from "../../helpers/ResourceListHelper";
import React from "react";

const PrivacyPartners = (props) => {
  const {
    validatorClass,
    receiveInfoFromPartner, partnerTableDefault, partnerTable,
    handleChange, handleArrayAdded, handleArrayRemoved, handleArrayChange, handleTogglePartner,
  } = props;

  const renderPartnerItem = (partner, id, index) => {
    const name = 'partnerTable';
    return (
      <Card sectioned title={partner.name}
            actions={ResourceListHelper.itemAction(name, index, handleArrayRemoved, false, true)}>
        <ResourceItem id={index}>
          <FormLayout>
            <FormLayout.Group>
              <V>
                <TextField label={CsI18n.t('partner_table.name')} value={partner.name}
                           onChange={handleArrayChange(name, index, 'name')} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
              <V>
                <TextField label={CsI18n.t('partner_table.function')} value={partner.function}
                           onChange={handleArrayChange(name, index, 'function')} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
            </FormLayout.Group>
            <FormLayout.Group>
              <V>
                <TextField label={CsI18n.t('partner_table.country')} value={partner.country}
                           onChange={handleArrayChange(name, index, 'country')} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
              <V>
                <TextField label={CsI18n.t('partner_table.privacy_policies')} value={partner.privacy_policies}
                           onChange={handleArrayChange(name, index, 'privacy_policies')} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
            </FormLayout.Group>
            <FormLayout.Group>
              <V>
                <TextField label={CsI18n.t('partner_table.purposes')} value={partner.purposes}
                           onChange={handleArrayChange(name, index, 'purposes')} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
            </FormLayout.Group>
          </FormLayout>
        </ResourceItem>
      </Card>
    )
  }

  return (
    <Layout.AnnotatedSection description={CsI18n.t("privacy.annotate.desc.partners")}>
      <Card>
        <Card.Section>
          <p>{HeadingHelper.ltt('Receive information from partners', 'privacy.explain.receive_information_from_partners')}</p>
          <Switch
            className="react-switch"
            onChange={handleChange('receiveInfoFromPartner')}
            checked={receiveInfoFromPartner}
            uncheckedIcon={false}
            checkedIcon={false}
            aria-label={CsI18n.t("Receive information from partners")}
          />

          {receiveInfoFromPartner &&
          <div className="partner-table">
            <Banner>
              <Stack spacing="extraTight">
                {partnerTableDefault.map((partner, index) => {
                  const partnerName = partner.name,
                    include = partnerTable.map(item => item.name).includes(partnerName);
                  return (
                    <p key={partner.name} className="partner-tag"
                       data-index={index} data-name={partnerName} data-include={include}>
                      <Tag onClick={handleTogglePartner}>
                        <Badge status={include ? "success" : ""}>{partner.name}</Badge>
                      </Tag>
                    </p>
                  )
                })}
              </Stack>
            </Banner>
            <CsValidationForm name={validatorClass} realtime={true}>
              <ResourceList
                items={partnerTable}
                renderItem={renderPartnerItem}
                alternateTool={ResourceListHelper.addNewAction('partnerTable', handleArrayAdded)}
              />
            </CsValidationForm>
          </div>
          }
        </Card.Section>
      </Card>
    </Layout.AnnotatedSection>
  )
};

export default PrivacyPartners;